module.exports = __webpack_public_path__ + "img/moving_truck.23337ea5.png";